import React from "react";
import PropTypes from 'prop-types';
import { CardSection } from "../CardSection/CardSection";

export const Graduados = (props) => {
    if (!props.students || props.students.length <= 0) {
        return null;
    }

    // Filter only graduated students (graduados === true)
    const graduatedStudents = props.students.filter(student => {
        return student.graduados === true;
    });

    if (graduatedStudents.length <= 0) {
        return null;
    }

    // Transform students to card format
    const cardItems = graduatedStudents.map(student => ({
        name: student.name || 'Sin nombre',
        url: student.url_imagen || null,
        text: student.carrera || student.linea_investigacion || null,
    }));

    return (
        <CardSection 
            title="Graduados"
            items={cardItems}
        />
    );
}

Graduados.propTypes = {
    students: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        url_imagen: PropTypes.string,
        carrera: PropTypes.string,
        linea_investigacion: PropTypes.string,
        graduados: PropTypes.bool,
    })),
};

